export enum SuccessStoryClasses {
  LandingPageColumn1 = 'contentful-class-success-stories-landing-two-col',
  VideoButton = 'success-stories-landing-two-col-video-btn',
  Quote = 'success-story-quote',
  Banner = 'success-stories-landing-banner',
}

export enum SuccessStoryDesc {
  TitleImage = 'Success story title image',
  CircleImage = 'Success story circle image',
}

export enum MatchClasses {
  ReviewBtn = 'contentful-class-match-resume-review-btn',
  HeroTitlesAndDescs = 'hero-titles-and-descs',
  ThreeColTitlesAndDescs = '3-col-titles-and-descs',
  HeroSection = 'tm-hero',
  ResumeReviewSection = 'tm-resume-review-section',
  HeroErrorSection = 'tm-hero-error',
  ThreeColSection = 'tm-3-col',
  ThreeColSectionForError = 'tm-3-col-for-error',
}

export enum TermsClasses {
  Hero = 'contentful-class-terms-hero',
}

export enum CommonClasses {
  // Banner
  MultiCompoBanner = 'multi-component-banner',

  // Text Column
  OrColumn = 'or-text-col',
  TextColumnWriter = 'text-column-writer',

  // Hero Text Section
  JobService = 'job-service',
  Contact = 'tr-contact-section',
  PrivacyPolicyHero = 'pp-hero',

  // Hero Text Two Column Section
  AboutImage = 'about-image',
}

export enum BindToFields {
  Main = 'Main',
  ComponentsWrapper = '[Wrapper] Components',
  WrapperColumnOne = '[Wrapper] Column 1',
  WrapperThreeFAQGroups = '[Wrapper 3] FAQ Groups',
  FAQForm = 'FAQ Form',
  RichTextH1 = '[H1] RichText',
  RichTextH2 = '[H2] RichText',
  RichTextH3 = '[H3] RichText',
  RichTextH4 = '[H4] RichText',
  RichTextH5 = '[H5] RichText',
  RichTextH6 = '[H6] RichText',
  WrapperColumnTwo = '[Wrapper] Column 2',
  WrapperTwoColumnOne = '[Wrapper 2] Column 1',
  TitleProductPackageDetail = 'Title - Product Package Detail',
  WrapperCTA = '[Wrapper] CTA',
  ParagraphCTA = '[p] CTA',
  HighlightTag = 'Highlight Tag',
  WrapperImage = '[Wrapper] Image',
  OutermostWrapper = '[Outermost Wrapper] Product Package Detail',
  SectionTextProductPackagesSection = 'Section Text - Product Packages Section',
  BodyHeroTextSection = 'Body - Hero Text Section',
  ContainerProductPackageRows = '[Container] Product Package Rows',
  Description = 'Description',
}

export interface CssEntry {
  bindToField: BindToFields
  className: string
  cssRules: {
    cssRules: string
  }
}

export enum ContentfulIds {
  ResumeServicesNavGroup = '7Dyyqao7aAlPAlTmgEvwu8',
  CVServicesNavGroup = 'oFRDMlem4imoGnlveHPMx',
  BuyNowButton = '2cbxLxt8cng6x2wCZv4XNs',
}
